import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const title = "Contact Kwame O. Sarfo | Solonet Properties, Ice Chest, Global Timber";
  const description =
    "Get in touch with Kwame O. Sarfo for real estate, bottled water, or timber export inquiries. Contact Solonet Properties, Ice Chest Mineral Water, or Global Timber Ltd for partnerships and purchases.";
  const keywords =
    "contact Kwame O. Sarfo, Solonet Properties contact, Ice Chest Mineral Water contact, Global Timber Ltd contact, Ghana real estate, bottled water, timber export, business inquiries, partnership Ghana";

  const businesses = [
    {
      name: "Solonet Properties",
      description: "Residential and commercial real estate solutions across Ghana.",
      contact: "+233 25 743 4375",
      website: "https://solonetproperties.com",
    },
    {
      name: "Ice Chest Mineral Water",
      description: "Pure, refreshing bottled water trusted for quality and taste.",
      contact: "+233 53 110 0073 / +233 53 1100 0074",
      website: "https://icechestmineralwater.com",
    },
    {
      name: "Global Timber Ltd",
      description: "Exporting premium Ghanaian hardwood to international markets.",
      contact: "",
      website: "#",
    },
  ];

  return (
    <section
      id="contact"
      className="relative bg-[#0a0a0a] text-white py-20 px-6 md:px-20 overflow-hidden"
    >
      {/* SEO META TAGS */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://solonetproperties.com/contact" />
        <link rel="canonical" href="https://solonetproperties.com/contact" />
      </Helmet>

      {/* Page Header */}
      <div className="text-center max-w-3xl mx-auto mb-16">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-5xl md:text-6xl font-playfair text-[#d4af37]"
        >
          Get in Touch
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-4 text-gray-400 text-lg"
        >
          For property purchases, water supply, timber exports, or business
          partnerships reach out today.
        </motion.p>
      </div>

      {/* Business Contact Cards */}
      <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {businesses.map((biz, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            className="bg-[#111]/90 border border-[#d4af37]/30 rounded-2xl p-6 text-center shadow-[0_0_25px_rgba(212,175,55,0.15)] hover:shadow-[0_0_35px_rgba(212,175,55,0.3)] transition-all duration-300"
          >
            <h3 className="text-[#d4af37] text-xl font-semibold mb-3">
              {biz.name}
            </h3>
            <p className="text-gray-400 mb-4">{biz.description}</p>
            <p className="text-gray-300 font-medium mb-4">
               {biz.contact}
            </p>
            <a
              href={biz.website}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#d4af37] text-black px-5 py-2 rounded-full font-semibold hover:bg-[#b8962f] transition"
            >
              Visit Website
            </a>
          </motion.div>
        ))}
      </div>

      {/* Contact Form */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="mt-20 max-w-3xl mx-auto bg-[#111]/90 border border-[#d4af37]/20 rounded-2xl p-8 shadow-[0_0_25px_rgba(212,175,55,0.15)]"
      >
        <h2 className="text-2xl font-playfair text-[#d4af37] mb-6 text-center">
          Send a Message
        </h2>
        <form className="space-y-4">
          <input
            type="text"
            placeholder="Full Name"
            className="w-full p-3 bg-transparent border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:border-[#d4af37]"
          />
          <input
            type="email"
            placeholder="Email Address"
            className="w-full p-3 bg-transparent border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:border-[#d4af37]"
          />
          <textarea
            placeholder="Your Message"
            rows="5"
            className="w-full p-3 bg-transparent border border-gray-600 rounded-lg text-gray-200 focus:outline-none focus:border-[#d4af37]"
          ></textarea>
          <button
            type="submit"
            className="w-full bg-[#d4af37] text-black py-3 rounded-lg font-semibold hover:bg-[#b8962f] transition"
          >
            Send Message
          </button>
        </form>
      </motion.div>
    </section>
  );
};

export default Contact;
